import {actionTypes} from "../storeConstants";

export const authToggleAction = (authorized) => {
    return ({
        type: actionTypes.TOGGLE_AUTHORIZED,
        payload: authorized
    });
}